import { apiProxyRequest } from "Api/apiProxyRequest";

import type { Me } from "./types";

export const getMeRequest = () => apiProxyRequest<Me>(`/me`);
